import { registerQueryCallback } from './queryCallbackRegistry'

import { SUMMARY_REPORT_ID, reportRouteForReportId } from '@/features/reports'

/**
 * App-side composition for module 08's `?report_id` deep link (v3 router/index.js:159–164):
 * the id resolves through the reports page manifest to a route name and the seam `replace`s
 * to it. v3 read `report.url` off the store's `linksName` overlay; v4 owns the map in
 * `configs/pages.ts`. Summary's own report id keeps its v3 target. Unknown ids no-op (stay).
 */
export function registerReportQueryCallbacks(): void {
  registerQueryCallback('report_id', ({ path, value }) => {
    const reportId = Number(value)
    if (!Number.isInteger(reportId)) return
    if (reportId === SUMMARY_REPORT_ID) return { redirect: { name: 'Summary' } }
    // Customer Intelligence is a bespoke vertical host whose page-context registration has not
    // landed yet. Its v3 linksName row nevertheless owns report 67 (ledger A18).
    const routeName = reportId === 67 ? 'CustomerIntelligence' : reportRouteForReportId(reportId)
    // The retained Customer Intelligence ingress deliberately carries report_id=67. Once the
    // browser is already on that exact owner route, redirecting to the same named route would do
    // nothing except erase the query state (ledger A18 / ORP-20074).
    if (
      reportId === 67 &&
      routeName === 'CustomerIntelligence' &&
      path === '/marketing-insights/customer-intelligence'
    ) {
      return { preserve: true }
    }
    return routeName ? { redirect: { name: routeName } } : undefined
  })
}
